import type {
    AppSubmodule,
    ExposedMenu,
    SideLink,
} from '@moniebook-web/components/widgets/sidebar';
import { ComputerLine } from '@moniebook-web/icons/device/computer-line';
import { DeviceLine } from '@moniebook-web/icons/device/device-line';
import { ApplicationModule, MENU_SECTIONS } from '@moniebook-web/types';

export const registersMenu: ExposedMenu = {
    menuGroups: [],
    submenu: [
        {
            sectionId: MENU_SECTIONS.SALES_CHANNELS,
            order: 2,
            accessCodeList: ['MANAGE_REGISTER'],
            name: 'Registers',
            to: '/dashboard/registers',
            icon: <ComputerLine />,
        },
    ] as SideLink[],
    modules: [],
    subModules: [
        {
            parentId: ApplicationModule.MORE,
            order: 2,
            accessCodeList: ['MANAGE_REGISTER'],
            name: 'Registers',
            to: '/dashboard/registers',
            icon: <DeviceLine />,
        },
    ] as AppSubmodule[],
};
